(() => {
  // Stati: desktop 5→3, mobile 2→1
  // Usiamo le stesse classi per semplicità
  const columnStates = [5, 3]; // 0 = vista normale (5 o 2), 1 = vista zoom (3 o 1)
  let currentIndex = 0;

  const saved = localStorage.getItem('productGridColumns');
  if (saved && columnStates.includes(parseInt(saved))) {
    currentIndex = columnStates.indexOf(parseInt(saved));
  }

  const body = document.body;

const updateGridClasses = () => {
    // Aggiungiamo una classe che indica che stiamo animando
    body.classList.add('is-animating');
    
    body.classList.remove('grid-cols-5', 'grid-cols-3');
    const cols = columnStates[currentIndex];
    body.classList.add(`grid-cols-${cols}`);
    localStorage.setItem('productGridColumns', cols);
    window.dispatchEvent(new Event('resize'));
    // Rimuoviamo la classe dopo che l'animazione è finita (0.6s)
    setTimeout(() => {
      body.classList.remove('is-animating');
    }, 600);

    const btn = document.querySelector('.grid-zoom-btn');
    if (btn) {
      if (currentIndex === 0) {
        btn.textContent = '+';
        btn.setAttribute('aria-label', 'Ingrandisci prodotti');
      } else {
        btn.textContent = '−';
        btn.setAttribute('aria-label', 'Torna alla vista normale');
      }
    }
  };

  const createSingleControl = () => {
    if (document.querySelector('.grid-zoom-controls')) return;

    const container = document.createElement('div');
    container.className = 'grid-zoom-controls';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'grid-zoom-btn';
    button.textContent = currentIndex === 0 ? '+' : '−';
    button.setAttribute('aria-label', currentIndex === 0 ? 'Ingrandisci prodotti' : 'Torna alla vista normale');

    container.appendChild(button);

    if (!document.querySelector('.resource-list--grid') && !window.Shopify?.designMode) return;

    const headerLeft = document.querySelector('.header__column--left');
    if (headerLeft) {
      headerLeft.insertBefore(container, headerLeft.firstChild);
    }

    button.addEventListener('click', () => {
      currentIndex = (currentIndex + 1) % columnStates.length;
      updateGridClasses();
    });
  };

  updateGridClasses();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createSingleControl);
  } else {
    createSingleControl();
  }

  const observer = new MutationObserver(createSingleControl);
  const target = document.querySelector('#header-group') || document.body;
  observer.observe(target, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', createSingleControl);
})();